
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REQUEST_DEVICE_LOG_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { requestDeviceLogResult } from 'Redux/actions';
import { clientPOST } from 'Core/data/RestApi';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* requestDeviceLog({ payload }) {
    try {
        const headers = {
            'Content-Type': 'application/json'
        };

        let QUERY = `
            mutation updateVidFleetSendLogRequest ($unitId: Int!, $description: String!) {
                result: updateVidFleetSendLogRequest (unitId: $unitId, description: $description)
            }
          `;

          let result = yield call(
            clientMutation,
            QUERY,
            {
                unitId: payload?.id,
                description: payload?.request
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (result) {
            result = JSON.parse(result.result)
            yield put(requestDeviceLogResult({ result: result }))
        }

    } catch (exc) {
        let errorResponse = exc;
        if (exc.request && exc.request.response)
            errorResponse = JSON.parse(exc.request.response)
        yield put(requestDeviceLogResult({ error: errorResponse }));
        
        ExceptionManager(
            exc,
            "Modules/devices/.components/requestDeviceLog/redux/saga",
            "requestDeviceLog",
        )
    }
}

function* watchMethods() {
    yield takeEvery(REQUEST_DEVICE_LOG_REQUEST, requestDeviceLog);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}